// Privana-authored presentation only; tenant content and evidence remain verbatim.
export default {
  "copy": {
    "selectAnActiveFrameworkVersion": "Sélectionnez une version de cadre actif.",
    "thisFrameworkIsNotApplicableToThisClub": "Ce cadre n'est pas applicable à ce club.",
    "selectACompletedAssessmentFromTheSameFramework": "Sélectionnez une évaluation effectuée dans le même cadre.",
    "aCompletedPriorAssessmentIsRequired": "Une évaluation préalable terminée est requise.",
    "selectAnActiveMemberOfThisClubSStaff": "Sélectionnez un membre actif du personnel de ce club.",
    "startTheAssessmentBeforeEvaluatingControls": "Commencez l'évaluation avant d'évaluer les contrôles.",
    "completedAndCancelledAssessmentsAreImmutable": "Les évaluations terminées et annulées sont immuables.",
    "selectAValidAssessmentResult": "Sélectionnez un résultat d'évaluation valide.",
    "addAMeaningfulNarrativeForThisResult": "Ajouter un récit significatif pour ce résultat.",
    "evaluateEveryControlBeforeCompletingTheAssessment": "Évaluer chaque contrôle avant de terminer l'évaluation.",
    "youDoNotHavePermissionToPerformThisOperation": "Vous n'avez pas la permission d'effectuer cette opération.",
    "theAssessmentWasNotFoundForThisClub": "L'évaluation n'a pas été trouvée pour ce club.",
    "anActiveFindingAlreadyExistsForThisAssessmentResult": "Une constatation active existe déjà pour ce résultat d'évaluation.",
    "onlyPartiallyCompliantOrNonCompliantResultsCanBecomeFindings": "Seuls les résultats partiellement fiables ou non compatibles peuvent devenir des constatations.",
    "selectLowMediumHighOrCritical": "Sélectionnez Low, Medium, High ou Critical.",
    "enterAFindingTitle": "Entrez un titre de recherche.",
    "describeTheComplianceDeficiency": "Décrivez le manque de conformité.",
    "theAssessmentOperationCouldNotBeCompleted": "Impossible de terminer l’opération d’évaluation.",
    "assessments": "Évaluations",
    "evaluateEveryCanonicalControlInAnActiveFrameworkVersion": "Évaluer chaque contrôle canonique dans une version de cadre active.",
    "newAssessment": "Nouvelle évaluation",
    "searchAssessments": "Évaluations de la recherche",
    "searchAssessments2": "Les évaluations de recherche...",
    "status": "Statut",
    "framework": "Cadre",
    "assessmentType": "Type d ' évaluation",
    "all": "Tous",
    "loadingAssessments": "Chargement des évaluations...",
    "noAssessmentsYet": "Pas encore d ' évaluation",
    "assessmentsEvaluateYourClubAgainstTheControlsInAnActiveComplianceFramework": "Les évaluations évaluent votre club contre les contrôles dans un cadre de conformité actif.",
    "createAssessment": "Créer une évaluation",
    "assessment": "Évaluation",
    "version": "Version",
    "type": "Type",
    "owner": "Propriétaire",
    "progress": "Progression",
    "started": "Démarré",
    "completed": "Terminé",
    "updated": "Mis à jour",
    "evaluated": " évaluée",
    "selectActiveFrameworkVersion": "Sélectionnez la version active du cadre",
    "controls": "Contrôles",
    "assessmentTitle": "Titre d ' évaluation",
    "defaultToMe": "Par défaut.",
    "loadingCompletedAssessments": "Chargement des évaluations achevées...",
    "selectCompletedPriorAssessment": "Sélectionnez l'évaluation préalable terminée",
    "completed2": "· Complété",
    "noCompletedAssessmentsAreAvailableForReassessmentAgainstThisFramework": "Il n ' est pas possible de procéder à une nouvelle évaluation à l ' aide de ce cadre.",
    "createDraftAssessment": "Créer un projet d ' évaluation",
    "unassigned": "Non attribué",
    "created": "Créé",
    "complete": "% complet",
    "startAssessment": "Évaluation de la mise en œuvre",
    "completeAssessment": "Évaluation complète",
    "cancel": "Annuler",
    "searchControls": "Contrôles de recherche...",
    "category": "Catégorie",
    "result": "Résultat",
    "importance": "Importance",
    "controlVersion": "· Version de contrôle {version}",
    "requirement": "Exigence",
    "guidance": "Orientation",
    "applicabilityGuidance": "Orientation de l ' applicabilité",
    "evaluationMethod": "Méthode d ' évaluation",
    "evidenceMethod": "Méthode de preuve",
    "reviewFrequency": "Fréquence de contrôle",
    "currentAssessmentResult": "Résultat des évaluations en cours",
    "assessmentNarrative": "Document d ' évaluation",
    "saveEvaluation": "D ' évaluation",
    "finding": "Trouver",
    "raiseFinding": "Relèvement",
    "title": "Titre",
    "description": "Description",
    "severity": "Gravité",
    "onlyCompletedAssessmentsCanBeUsedForAnAuditPack": "Seules les évaluations achevées peuvent être utilisées pour un dossier de vérification.",
    "thisAuditPackCouldNotBeFound": "Ce pack de vérification n'a pas pu être trouvé.",
    "thisAuditPackCanNoLongerBeChanged": "Ce pack de vérification ne peut plus être modifié.",
    "thisAuditPackIsAlreadyBeingGenerated": "Ce pack de vérification est déjà en cours de production.",
    "generationOwnershipChangedRefreshAndTryAgain": "La propriété de la génération a changé. Refresh et essayer de nouveau.",
    "tooManyCurrentEvidenceDocumentsAreInScope": "Trop de documents de preuve actuels sont en portée.",
    "theEvidencePackageIsTooLargeToGenerateSafely": "Le paquet Preuve est trop grand pour générer en toute sécurité.",
    "aCurrentEvidenceDocumentCouldNotBeRetrievedNoIncompletePackageWasGenerated": "Un document de preuve actuel n'a pas pu être récupéré. Aucun paquet incomplet n'a été généré.",
    "enterARationaleBeforeVoidingThisAuditPack": "Entrez une justification avant d'annuler ce bloc de vérification.",
    "unableToCompleteTheAuditPackOperation": "Incapable de compléter l'opération de la trousse de vérification.",
    "loadingAssuranceOverview": "Aperçu de l'assurance de chargement...",
    "setUpYourComplianceProgramme": "Mise en place de votre programme de conformité",
    "privanaCanHelpYouBuildAStructuredAssuranceProgrammeForYourClub": "Privana peut vous aider à construire un programme d'assurance structuré pour votre club.",
    "chooseAFramework": "Choisissez un cadre",
    "startWithAPrivanaTemplateOrCreateYourOwn": "Commencez par un modèle Privana ou créez votre propre.",
    "reviewYourControls": "Révisez vos contrôles",
    "tailorTheSuggestedRequirementsToYourClub": "Adaptez les exigences proposées à votre club.",
    "runYourFirstAssessment": "Exécutez votre première évaluation",
    "establishYourCurrentCompliancePosition": "Établissez votre position de conformité actuelle.",
    "step": "Étape",
    "setUpCompliance": "Mise en place de la conformité",
    "overallCompliance": "Conformité générale",
    "notAssessed": "Non évaluée",
    "openFindings": "Conclusions ouvertes",
    "actionsDue": "Mesures à prendre",
    "auditReadiness": "Vérification de la lecture",
    "notEnoughData": "Pas assez de données",
    "assuranceReadinessIndicatorNotCertification": "Indicateur de prêt d ' assurance, non de certification",
    "executiveAssurance": "Assurance",
    "currentAssurancePostureFromCanonicalComplianceRecords": "La posture d'assurance actuelle des dossiers de conformité canonique.",
    "readinessDimensions": "Dimensions de lecture",
    "notMeasurable": "Pas mesurable",
    "recentComplianceActivity": "Récentes activités de conformité",
    "timesShownIn": "Heures indiquées dans",
    "auditPacks": "Dossiers d’audit",
    "immutableVersionedAssuranceSnapshotsForFormalReview": "Instantanés d'assurance immuables et versions pour examen formel.",
    "newAuditPack": "Nouveau plan de vérification",
    "searchAuditPacks": "Dossiers de vérification de la recherche",
    "searchPacks": "Les paquets de recherche...",
    "statusFilter": "Filtre à statut",
    "allStatuses": "Tous les statuts",
    "draft": "Brouillon",
    "generating": "Génératrice",
    "generated": "Générée",
    "void": "Annulé",
    "noAuditPacks": "Pas de trousses de vérification",
    "createAPackFromACompletedAssessment": "Créer un pack à partir d'une évaluation effectuée.",
    "pack": "Pack",
    "generatedBy": "Générée par",
    "documents": "Documents",
    "selectCompletedAssessment": "Sélectionnez l'évaluation complétée...",
    "includeEvidenceDocuments": "Inclure des documents de preuve",
    "createDraft": "Créer un projet de loi",
    "noDescriptionProvided": "Aucune description n'a été fournie.",
    "generateAuditPack": "Générer un pack d'audit",
    "generatingAuditPack": "Generating Audit Pack...",
    "theImmutableReportAndAuthorisedEvidencePackageAreBeingPreparedRefreshToCheckItsStatus": "Le rapport immuable et le dossier de preuve autorisé sont en cours de préparation. Refresh to check its status.",
    "manifestV": "Manifeste v",
    "downloadPDF": "Télécharger PDF",
    "downloadEvidencePackage": "Télécharger le dossier de preuve",
    "voidAuditPack": "Ensemble de vérifications vide",
    "voidingIsTerminalExplainWhyThisDraftMustNotBeGenerated": "Voiding est terminal. Expliquez pourquoi ce projet ne doit pas être généré.",
    "voidRationale": "Null rationale",
    "voidRationale2": "Void rationale...",
    "actionDue": "Mesures à prendre",
    "safetyReview": "Examen de la sécurité",
    "complianceDate": "Date de conformité",
    "owner2": "Propriétaire:",
    "priority": "priorité",
    "overdue": "En retard",
    "open": "Ouvrir",
    "youDoNotHaveAccessToTheComplianceCalendar": "Vous n'avez pas accès au Calendrier de Conformité.",
    "theComplianceCalendarCouldNotBeLoaded": "Le calendrier de conformité n'a pas pu être chargé.",
    "complianceCalendar": "Calendrier d ' application",
    "dueThisWeek": "Dûre cette semaine",
    "next30Days": "30 prochains jours",
    "safetyReviewsDue": "Examens de sécurité attendus",
    "previousMonth": "précédent mois",
    "today": "Aujourd’hui",
    "nextMonth": "Le mois suivant",
    "calendarView": "Vue du calendrier",
    "calendar": "Calendrier",
    "agenda": "Ordre du jour",
    "filters": "Filtres",
    "eventCategory": "Catégorie événementiel",
    "allEvents": "Tous les événements",
    "actions": "Actions",
    "frameworks": "Cadres",
    "safetyReviews": "Examens de sécurité",
    "timing": "Chronométrage",
    "allDates": "Toutes les dates",
    "upcoming": "À venir",
    "loadingComplianceDates": "Dates de conformité de chargement",
    "loadingComplianceDates2": "Chargement des dates de conformité...",
    "sun": "Soleil",
    "mon": "Mon Dieu !",
    "tue": "Tue",
    "wed": "Wed",
    "thu": "Thu",
    "fri": "Fri.",
    "sat": "Sat",
    "more": "plus",
    "selectedDayAgenda": "Ordre du jour",
    "noComplianceItemsForThisDay": "Aucun élément de conformité pour cette journée.",
    "noComplianceDatesInThisPeriod": "Aucune date de conformité pour cette période",
    "today2": " Aujourd'hui",
    "date": "Date",
    "andTime": " temps et temps",
    "sourceReference": "Référence de la source",
    "context": "Contexte",
    "priority2": "Priorité",
    "close": "Fermer",
    "thatKeyAndVersionAlreadyExists": "Cette clé et cette version existent déjà.",
    "activeAndRetiredControlsCannotBeEditedCreateANewVersionInstead": "Les contrôles actifs et retraités ne peuvent pas être modifiés. Créez une nouvelle version.",
    "onlyDraftFrameworkVersionsCanHaveTheirControlsChanged": "Seules les versions provisoires peuvent modifier leurs contrôles.",
    "activateEveryAttachedControlBeforeActivatingThisVersion": "Activer chaque contrôle joint avant d'activer cette version.",
    "onlyActiveControlsCanBeAssignedToAFrameworkVersion": "Seules les commandes actives peuvent être assignées à une version cadre.",
    "controlOrderingMustUseNonNegativeWholeNumbers": "La commande de contrôle doit utiliser des numéros entiers non négatifs.",
    "eachAssignedControlMustHaveAUniqueOrder": "Chaque commande assignée doit avoir un ordre unique.",
    "thisFrameworkAlreadyHasAnActiveVersionSupersedeOrRetireItExplicitlyFirst": "Ce cadre a déjà une version active. Supersede ou retirez-le explicitement en premier.",
    "aRationaleIsRequiredWhenAFrameworkIsNotApplicable": "Une justification est requise lorsqu'un cadre n'est pas applicable.",
    "theEffectiveToDateMustBeOnOrAfterEffectiveFrom": "La date d'entrée en vigueur doit être à compter de la date d'entrée en vigueur ou après celle-ci.",
    "youDoNotHaveComplianceEditPermission": "Vous n'avez pas la permission de modifier la conformité.",
    "attachAtLeastOneActiveControlBeforeActivation": "Attache au moins un contrôle actif avant l'activation.",
    "createAFrameworkVersionBeforeActivatingThisFramework": "Créer une version cadre avant d'activer ce cadre.",
    "thisLifecycleActionIsNotValidForTheCurrentStatus": "Cette action de cycle de vie n'est pas valable pour l'état actuel.",
    "theComplianceOperationCouldNotBeCompleted": "L'opération de conformité n'a pas pu être terminée.",
    "no": "Non",
    "yet": " encore",
    "controlsDefineTheRequirementsUsedByComplianceFrameworksAndAssessments": "Les contrôles définissent les exigences utilisées par les cadres de conformité et les évaluations.",
    "frameworksOrganiseReusableControlsIntoADefinedComplianceProgramme": "Les cadres organisent des contrôles réutilisables dans un programme de conformité défini.",
    "create": "Créer",
    "control": "Contrôle",
    "privanaWillGenerateTheControlReferenceAutomatically": "Privana générera automatiquement la référence de Contrôle.",
    "controlDefinition": "Définition du contrôle",
    "assuranceSettings": "Paramètres d ' assurance",
    "controlLibrary": "Bibliothèque de contrôle",
    "reusableVersionedRequirementsForYourComplianceProgrammes": "Besoins réutilisables et versions pour vos programmes de conformité.",
    "browsePrivanaLibrary": "Parcourez la bibliothèque Privana",
    "newControl": "Nouveau contrôle",
    "searchControls2": "Contrôles de recherche",
    "allCategories": "Toutes les catégories",
    "allImportance": "Toute l'importance",
    "loadingControls": "Chargement des commandes...",
    "evaluation": "Évaluation",
    "evidence": "Preuve",
    "createControl": "Créer un contrôle",
    "frameworkReferences": "Références au cadre",
    "edit": "Modifier",
    "activate": "Activation",
    "createNewVersion": "Créer une nouvelle version",
    "retire": "Retraite",
    "editDraftControl": "Modifier le projet de contrôle",
    "saveChanges": "Sauvegarder les changements",
    "createNewControlVersion": "Créer une nouvelle version de contrôle",
    "createDraftVersion": "Créer un projet de version",
    "availableControls": "Commandes disponibles",
    "available": "disponible",
    "searchAvailableControls": "Recherche de contrôles disponibles",
    "searchActiveControls": "Rechercher Contrôles actifs...",
    "availableControlCategory": "Catégorie de contrôle disponible",
    "availableControlImportance": "Importance de contrôle disponible",
    "version2": "version ·",
    "add": "Ajouter",
    "allMatchingControlsAreAlreadyAssigned": "Tous les contrôles correspondants sont déjà assignés.",
    "assignedControls": "Contrôles assignés",
    "assigned": "c)",
    "searchAssignedControls": "Contrôles de recherche",
    "searchAssignedControls2": "Rechercher Contrôles assignés...",
    "frameworkReferenceFor": "Référence du cadre",
    "frameworkReferenceOptional": "Référence du cadre (facultatif)",
    "moveUp": "Avancez.",
    "moveDown": "Bougez-vous.",
    "removeControl": "Supprimer le contrôle",
    "noAssignedControlsMatchThisSearch": "Aucune commande assignée correspond à cette recherche.",
    "controlsAssigned": "Contrôles assignés",
    "privanaComplianceLibrary": "Privana Bibliothèque de conformité",
    "loadingPrivanaTemplates": "Chargement de Privana modèles...",
    "privanaLibraryIsTemporarilyUnavailableYouCanStillBuildACustomFramework": "Privana La bibliothèque est temporairement indisponible. Vous pouvez encore construire un cadre personnalisé.",
    "privanaTemplatesAreGuidanceAndShouldBeTailoredWithAppropriateProfessionalAdvice": "Privana modèles sont des conseils et doivent être adaptés avec des conseils professionnels appropriés.",
    "chooseTheSuggestedControlsToCopyIntoYourDraftProgrammeYouCanReviewAndTailorThemBeforeActivation": "Choisissez les commandes suggérées pour copier dans votre programme de projet. Vous pouvez les examiner et les adapter avant l'activation.",
    "selectAll": "Sélectionnez",
    "clearAll": "Tout effacer",
    "suggestedEvidence": "· Preuves suggérées:",
    "reviewDuringTailoring": "Examen lors de l ' adaptation",
    "privanaTemplatesProvideAStructuredStartingPointForYourClubSAssuranceProgrammeReviewAndTailorEachProgrammeToYourOrganisationJurisdictionInsurerAndProfessionalAdviceBeforeActivation": "Privana modèles fournissent un point de départ structuré pour le programme d'assurance de votre club. Examiner et adapter chaque programme à votre organisation, juridiction, assureur et conseils professionnels avant l'activation.",
    "searchTemplates": "Modèles de recherche",
    "searchTemplates2": "Modèles de recherche...",
    "templateCategory": "Catégorie de modèles",
    "recommended": "Recommandation recommandée",
    "privanaTemplate": "Modèle privana ·",
    "controls2": "Contrôles",
    "preview": "Aperçu",
    "useThisTemplate": "Utilisez ce modèle",
    "backToTemplates": "Retour aux modèles",
    "selected": "sélectionné",
    "creatingDraft": "Création d'un projet...",
    "adoptDraftControls": "Adopter un projet de contrôle",
    "createDraftFramework": "Créer un projet de cadre",
    "frameworkRetiredSuccessfully": "Le cadre a pris sa retraite avec succès.",
    "notConfigured": "Non configuré",
    "createAndManageVersionedComplianceProgrammes": "Créer et gérer des programmes de conformité en version anglaise.",
    "newFramework": "Nouveau cadre",
    "searchFrameworks": "Cadres de recherche",
    "searchFrameworks2": "Les cadres de recherche...",
    "frameworkStatus": "État d ' avancement",
    "loadingFrameworks": "Chargement des cadres...",
    "chooseHowYourClubWantsToEstablishItsAssuranceProgramme": "Choisissez comment votre club veut établir son programme d'assurance.",
    "startFromPrivanaLibrary": "Commencer à partir de Privana Bibliothèque",
    "chooseACuratedAssuranceProgrammeAndTailorTheSuggestedControls": "Choisissez un programme d'assurance et adaptez les contrôles proposés.",
    "buildACustomFramework": "Construire un cadre personnalisé",
    "createAProgrammeFromScratchForAClubSpecificOrExternalRequirement": "Créer un programme à partir de zéro pour une exigence spécifique au club ou externe.",
    "currentVersion": "Version actuelle",
    "versions": "Versions",
    "applicability": "Applicabilité",
    "notSet": "Non défini",
    "createFrameworkAndFirstDraftVersion": "Créer un cadre et une première version",
    "privanaWillGenerateTheFrameworkReferenceAndInitialVersionAutomatically": "Privana générera automatiquement la référence de Cadre et la version initiale.",
    "name": "Nom",
    "versionTitle": "Titre de version",
    "effectiveFrom": "Efficace à partir de",
    "effectiveTo": "Efficacité",
    "createdFromPrivanaComplianceLibrary": "Créé à partir de Privana Bibliothèque de conformité",
    "versionStatus": "État de la version",
    "activeControls": "Contrôles actifs",
    "awaitingReview": "Examen attendu",
    "reviewAndActivateAllAttachedControlsFirst": "Révisez et activez d'abord tous les contrôles joints.",
    "activateVersion": "Activer la version",
    "manageControls": "Gérer les contrôles",
    "editApplicability": "Modifier l ' applicabilité",
    "setApplicability": "Définir l'applicabilité",
    "newVersion": "Nouvelle version",
    "moreVersionActions": "Plus d'actions de version",
    "supersedeVersion": "Version Supersede",
    "markThisVersionAsHistorical": "Marquer cette version comme historique",
    "retireVersion": "Version de la retraite",
    "removeFromFutureActiveUse": "Supprimer de l ' utilisation active future",
    "deEmphasisedDuringInitialSetup": "De-emphasized during initial setup",
    "activateFramework": "Cadre d ' action",
    "moreFrameworkActions": "Actions-cadres",
    "retireFramework": "Cadre de retraite",
    "removeFromFutureAssuranceUse": "Supprimer de l ' assurance future",
    "versionHistory": "Version historique",
    "noStartDate": "Aucune date de début",
    "openEnded": "Ouvert",
    "selectedVersionWorkspace": "Sélection de l'espace de travail",
    "reviewSuggestedControls": "Examen suggéré Contrôles",
    "controlsReviewed": "Contrôles examinés",
    "reviewed": "examiné",
    "anAuthorizedControlsEditorMustReviewAndActivateTheseControls": "Un éditeur autorisé de contrôle doit examiner et activer ces contrôles.",
    "reviewControls": "Contrôles d ' examen",
    "readyToActivateVersion": "Prêt à activer la version",
    "total": "Total",
    "active": "Actif",
    "awaitingReview2": "Attending Review",
    "retired": "Retraite",
    "searchControls3": "Contrôles de recherche",
    "searchControls4": "Contrôles de recherche...",
    "controlStatusFilter": "Filtre de contrôle",
    "controlCategoryFilter": "Catégorie de contrôle filter",
    "frameworkOrder": "Ordonnance cadre",
    "uncategorised": "Non classé",
    "noReference": "Pas de référence",
    "noControlsMatchTheseFilters": "Aucun contrôle ne correspond à ces filtres.",
    "createDraftFrameworkVersion": "Créer un projet de version cadre",
    "copyControlsFromVersion": "Contrôles de copie de la version",
    "doNotCopyControls": "Ne pas copier les contrôles",
    "searchSuggestedControls": "Recherche suggérée Contrôles",
    "reviewCategoryFilter": "Catégorie d'examen filter",
    "reviewImportanceFilter": "Note importance filter",
    "reviewStatusFilter": "État de l ' examen",
    "selectAllDraft": "Sélectionnez tous les projets",
    "clearSelection": "Sélection claire",
    "evidence2": "· Preuve :",
    "noRequirementSummary": "Pas de résumé d'exigence.",
    "openControl": "Commande ouverte",
    "activateSelectedControls": "Activer certains contrôles",
    "controlsEditPermissionRequired": "Contrôles éditer la permission requise",
    "chooseWhichActiveControlsBelongToThisDraftFrameworkVersionAndArrangeHowTheyAppearWithinTheProgramme": "Choisissez quels contrôles actifs appartiennent à ce projet de version-cadre et arrangez la façon dont ils apparaissent dans le programme.",
    "controlAssignmentsSaved": "Les missions de contrôle ont été enregistrées.",
    "discardUnsavedChanges": "Découper des changements non enregistrés ?",
    "yourStagedControlMembershipChangesWillNotBeSaved": "Vos changements d'adhésion au contrôle échelonné ne seront pas sauvegardés.",
    "keepEditing": "Continuer d'éditer",
    "discardChanges": "Changements de carte",
    "frameworkApplicability": "Applicabilité du cadre",
    "doesThisProgrammeApplyToYourClub": "Ce programme s'applique-t-il à votre club?",
    "recordWhetherThisFrameworkVersionAppliesToTheClubAndWhereUsefulTheReasonAndApplicablePeriod": "Veuillez indiquer si la présente version cadre s'applique au club et, le cas échéant, à la raison et à la période applicable.",
    "applicable": "Cas échéant",
    "underReview": "À l ' examen",
    "notApplicable": "Non applicable",
    "reasonThisDoesNotApply": "Raison qui ne s ' applique pas",
    "reviewNotes": "Notes d ' examen",
    "applicableFrom": "Applicable à partir",
    "applicableTo": "Applicable à",
    "theseOptionalDatesDefineThePeriodForWhichThisApplicabilityDecisionApplies": "Ces dates facultatives définissent la période pour laquelle cette décision d'applicabilité s'applique.",
    "saveApplicability": "Enregistrer l'applicabilité",
    "retireFramework2": "Cadre de retraite ?",
    "retiringThisFrameworkRemovesItFromFutureActiveAssuranceUseWhilePreservingItsVersionsAssessmentsFindingsActionsEvidenceAndAuditHistory": "Le retrait de ce cadre l'empêche d'utiliser l'assurance active à l'avenir tout en préservant ses versions, évaluations, constatations, actions, preuves et antécédents de vérification.",
    "retirementRationale": "Justification de la retraite",
    "programmeRetiredFollowingReplacementByAConsolidatedAssuranceFramework": "Programme à la retraite après remplacement par un cadre d ' assurance consolidé.",
    "supersedeFrameworkVersion": "Version cadre de Supersede ?",
    "retireFrameworkVersion": "Version du cadre de retraite?",
    "supersedingThisVersionMarksItAsHistoricalAndPreventsItFromBeingTreatedAsTheCurrentActiveVersionExistingAssessmentsFindingsActionsEvidenceAndAuditHistoryRemainUnchanged": "La révision de cette version la marque comme historique et l'empêche d'être traitée comme la version active actuelle. L'évaluation, les constatations, les actions, les preuves et l'historique des vérifications demeurent inchangées.",
    "retiringThisVersionRemovesItFromFutureActiveUseWhilePreservingItsHistoricalAssessmentsEvidenceAndAuditRecord": "Retirer cette version la retire de l'utilisation active future tout en préservant ses évaluations historiques, ses preuves et son dossier d'audit.",
    "supersedeRationale": "Raison de la supersédée",
    "replacedByThe2027AssuranceBaseline": "Remplacé par la référence d'assurance de 2027.",
    "evidenceWorkspaces": "Espaces de travail de preuve",
    "evidenceRegister": "Registre des preuves",
    "insuranceIntelligence": "Renseignements sur les assurances",
    "unableToLoadEvidence": "Incapable de charger des preuves.",
    "evidenceWasNotFound": "Des preuves n'ont pas été trouvées.",
    "unableToCreateEvidence": "Incapable de créer des preuves.",
    "uploadAGenuinePDFPNGOrJPEGDocument": "Téléchargez un véritable document PDF , PNG ou JPEG.",
    "filesMustBe20MBOrSmaller": "Les fichiers doivent être de 20 Mo ou plus.",
    "documentUploadFailedPleaseTryAgain": "Télécharger le document a échoué. Veuillez réessayer.",
    "thePrivateDocumentCouldNotBeOpened": "Le document privé ne pouvait pas être ouvert.",
    "unableToUpdateEvidence": "Incapable de mettre à jour la preuve.",
    "thatLifecycleTransitionIsNotAllowed": "Cette transition du cycle de vie n ' est pas autorisée.",
    "unableToLinkEvidence": "Incapable de relier la preuve.",
    "canonicalAssuranceRecordsSupportingYourComplianceProgramme": "Des dossiers d'assurance Canonical soutenant votre programme de conformité.",
    "addEvidence": "Ajouter des preuves",
    "activeEvidence": "Preuve active",
    "uploadedDocuments": "Documents téléchargés",
    "manualEvidence": "Preuves manuelles",
    "unlinkedEvidence": "Preuves non liées",
    "searchEvidence": "Preuve de recherche",
    "allSourceTypes": "Tous les types de sources",
    "manual": "Manuel",
    "uploadedDocument": "Document téléchargé",
    "allLinkedStates": "Tous les états liés",
    "linked": "Lié au lien",
    "unlinked": "Non lié",
    "noEvidenceYet": "Pas encore de preuve",
    "evidenceProvidesTheRecordsDocumentsAndAssuranceMaterialThatSupportYourComplianceControlsAssessmentsFindingsAndRemediation": "La preuve fournit les documents, les documents et les documents d'assurance qui appuient vos contrôles de conformité, vos évaluations, vos constatations et vos mesures correctives.",
    "captured": "Capturé",
    "links": "Liens",
    "createdBy": "Créé par",
    "previous": "Précédent",
    "page": "Page",
    "records": "dossiers",
    "next": "Suivant",
    "recordAnAttestationOrOtherManuallyCapturedAssuranceItem": "Enregistrer une attestation ou tout autre élément d'assurance capturé manuellement.",
    "uploadDocument": "Télécharger le document",
    "securelyAttachAPrivatePDFOrImageDocument": "Fixer en toute sécurité un PDF privé ou un document d'image.",
    "changeEvidenceType": "← Changer de type de preuve",
    "optionalSourceReference": "Source facultative",
    "capturedAt": "Capturé le",
    "file": "Fichier",
    "pDFPNGOrJPEGMaximum20MB": "PDF , PNG ou JPEG · maximum 20 MB",
    "sourceManualStatusActive": "Source: Manuel · Statut: Actif",
    "uploading": "Chargement...",
    "createEvidence": "Créer une preuve",
    "sourceType": "Type de source",
    "sourceSystem": "Système source",
    "sourceReference2": "Référence de la source",
    "createdAt": "Créé à",
    "updatedAt": "Mis à jour",
    "lifecycleReason": "Justification du cycle de vie",
    "sizeUnavailable": "Taille non disponible",
    "viewDownload": "Voir / Télécharger",
    "noDescription": "Pas de description.",
    "editMetadata": "Modifier les métadonnées",
    "supersede": "Remplacer",
    "withdraw": "Retrait",
    "saveMetadata": "Sauvegarder les métadonnées",
    "linkedTo": "Lié à",
    "unlinkEvidence": "Preuves non liées",
    "selectTarget": "Sélectionnez la cible",
    "linkEvidence": "Lien entre la preuve",
    "insuranceAnalysisComplete": "Analyse de l'assurance terminée",
    "viewInsights": "Vision de l'information",
    "viewInsuranceIntelligence": "Voir l'Assurance Intelligence",
    "needsClubReview": "L ' examen des besoins du club",
    "needsReview": "Examen des besoins",
    "theInsurancePolicySetCouldNotBeLoaded": "L'Assurance Policy Set n'a pas pu être chargé.",
    "liveProgressConnectionWasInterruptedYourAnalysisIsStillRunning": "La connexion en direct a été interrompue. Votre analyse est toujours en cours.",
    "viewComplianceImpact": "Incidences sur la conformité",
    "continueReview": "Poursuite de l ' examen",
    "reviewRecommendations": "Recommandations d ' examen",
    "uploadFailed": "Chargement échouée",
    "uploadAtLeastOneValidPDFBeforeAnalysis": "Charger au moins un PDF valide avant analyse.",
    "analysisCouldNotBeStarted": "L'analyse n'a pas pu être lancée.",
    "thisRecommendationHasAlreadyBeenReviewed": "Cette recommandation a déjà été examinée.",
    "weCouldnTSaveThisDecisionPleaseTryAgain": "Nous ne pouvions pas sauvegarder cette décision. Veuillez réessayer.",
    "frameworkVersionsCouldNotBeLoaded": "Les versions cadre ne pouvaient pas être chargées.",
    "reviewTheHighlightedControlFieldsBeforeCreatingIt": "Examiner les champs de contrôle mis en évidence avant de le créer.",
    "anotherAdoptionIsAlreadyInProgressPleaseRefreshInAMoment": "Une autre adoption est déjà en cours. S'il vous plaît rafraîchir dans un instant.",
    "theSelectedFrameworkVersionIsNoLongerEditable": "La versioncadre sélectionnée n'est plus modifiable.",
    "thisControlAlreadyExistsInYourClub": "Ce contrôle existe déjà dans votre club.",
    "weCouldnTAddThisLibraryControlPleaseTryAgain": "Nous ne pouvions pas ajouter ce contrôle de bibliothèque. Veuillez réessayer.",
    "weCouldnTCreateThisDraftControlPleaseTryAgain": "Nous ne pouvions pas créer ce projet de contrôle. Veuillez réessayer.",
    "thisControlMustBeActiveBeforeItCanBeAddedToTheFramework": "Ce contrôle doit être actif avant qu'il puisse être ajouté au Cadre.",
    "weCouldnTCancelThisFrameworkIntentionPleaseTryAgain": "Nous ne pouvions pas annuler cette intention. Veuillez réessayer.",
    "thisOutlookReminderAlreadyExists": "Ce rappel Outlook existe déjà.",
    "outlookReminderCreated": "Rappel Outlook créé.",
    "calendarPermissionIsNeededConnectOutlookCalendarWithoutChangingYourMailConnection": "La permission du calendrier est nécessaire. Connectez le calendrier Outlook sans modifier votre connexion par courrier.",
    "theOutlookReminderCouldNotBeCreated": "Le rappel Outlook n'a pas pu être créé.",
    "loadingInsurancePolicy": "Chargement de la politique d'assurance...",
    "insuranceIntelligence2": "← Renseignements sur l'assurance",
    "insuranceIntelligence3": "Renseignements sur l'assurance ·",
    "reviewComplete": "Examen complet",
    "reviewInProgress": "Examen en cours",
    "analysisComplete": "Analyse complète",
    "preparingAnalysis": "Analyse préliminaire",
    "reanalyse": "Réanalyser",
    "insurer": "Assureur",
    "policyNumber": "Numéro de la politique",
    "policyPeriod": "Période de politique générale",
    "primaryLimit": "Limite primaire",
    "excess": "Excès",
    "underwriter": "Assureur",
    "analysing": "Analyse",
    "of": "des",
    "pagesProcessed": "pages traitées",
    "yourPreviousCompletedAnalysisRemainsAvailableWhileThisAnalysisRuns": "Votre analyse effectuée antérieure demeure disponible pendant que cette analyse est en cours.",
    "analysisCouldNotBeCompleted": "L ' analyse n ' a pas pu être achevée",
    "yourDocumentsAndAnyPreviousCompletedAnalysisAreSafePleaseTryAgain": "Vos documents et toute analyse effectuée antérieurement sont sans danger. Veuillez réessayer.",
    "retryAnalysis": "Analyse des rentrées",
    "importantForYourAttention": "Important pour votre attention",
    "whyThisMatters": "Pourquoi cette question est importante ?",
    "page2": "page ·",
    "viewSource": "· Voir Source",
    "policyReview": "Examen des politiques",
    "privanaFoundRecommendationsFromThisPolicyReviewThemBeforeAnythingChangesInCompliance": "Privana ont trouvé des recommandations de cette politique. Examinez-les avant tout changement de conformité.",
    "reviewed2": "examiné ·",
    "remaining": "restants",
    "existingMatches": "les correspondances existantes ·",
    "suggestedControls": "les contrôles proposés ·",
    "dates": "dates ·",
    "needsReview2": "Examen des besoins",
    "existingControlsMatched": "Contrôles existants assortis",
    "privanaFoundControlsThatMayAlreadyAddressPolicyRequirements": "Privana a trouvé des contrôles qui pourraient déjà répondre aux exigences de la politique.",
    "suggestedControls2": "les contrôles suggérés",
    "requirementsThatMayNeedAnAdditionalControlOrClubReview": "Exigences qui peuvent avoir besoin d'un contrôle supplémentaire ou d'un examen de club.",
    "importantDates": "dates importantes",
    "policyDatesAndPreparationMilestonesIdentified": "Dates de la politique et étapes de préparation identifiées.",
    "review": "Examen",
    "matches": "Matchs",
    "suggestedControls3": "Contrôles suggérés",
    "dates2": "Dates",
    "reviewFilter": "Filtre à réaction",
    "whatThePolicyRequires": "Ce que la politique exige",
    "policyRequirement": "Prescriptions générales",
    "privanaSRecommendedMatch": "Privana ’s match recommandé",
    "privanaSSuggestedControl": "Privana ’s suggéré Contrôle",
    "draftARepeatablePolicyComplianceControl": "Projet de contrôle de la conformité à une politique répétable",
    "status2": "État :",
    "frameworks2": "Cadres:",
    "none": "Aucun",
    "latestAssessment": "Dernière évaluation:",
    "notAssessed2": "non acquittées",
    "evidence3": "Preuve :",
    "supported": "Appuie",
    "noCurrentSupport": "Aucun appui actuel",
    "strongMatch": "Un match fort",
    "possibleMatch": "Match possible",
    "whyPrivanaRecommendsIt": "Pourquoi Privana le recommande",
    "libraryProvenance": "Origine de la bibliothèque :",
    "version3": "version ·",
    "addedToFramework": "Ajouté au Cadre",
    "readyToAddToFramework": "Prêt à ajouter au cadre",
    "waitingForControlActivation": "Attendre l'activation du contrôle",
    "matchConfirmed": "Match confirmé",
    "notAMatch": "Pas un match.",
    "dismissed": "Rompez.",
    "libraryControlAdded": "Library Control ajouté",
    "draftControlCreated": "Projet de contrôle créé",
    "recommendationReviewed": "Recommandation révisée",
    "target": "Cible :",
    "viewControl": "Voir le contrôle",
    "adding": "Ajout...",
    "cancelling": "Annulant...",
    "cancelFrameworkIntention": "Annuler l ' intention du Cadre",
    "viewFramework": "Cadre de vision",
    "saving": "Enregistrement…",
    "confirmMatch": "Confirmer la correspondance",
    "markForReview": "Marque d ' examen",
    "addToMyControls": "Ajouter à mes contrôles",
    "createDraftControl": "Créer un projet de contrôle",
    "frameworkEditAccessIsRequired": "L'accès à la modification-cadre est requis",
    "addToFramework": "Ajouter au cadre",
    "createAddToFramework": "Créer et ajouter au référentiel",
    "controlsEditAccessIsRequiredToAdoptThisRecommendation": "Les contrôles éditent l'accès est nécessaire pour adopter cette recommandation.",
    "dismiss": "Rompez.",
    "youReAllCaughtUpInThisSection": "Vous êtes tous pris dans cette section.",
    "viewCompleted": "Voir terminé",
    "privanaDerivedMilestone": "Privana - jalon avancé",
    "policyDeadline": "Date limite",
    "policyPeriodDate": "Date d ' entrée en vigueur",
    "suggestedMilestoneDerivedFromPolicyInformationNotAContractualCondition": "Une étape suggérée dérivée de l'information sur les politiques — pas une condition contractuelle.",
    "viewInComplianceCalendar": "Calendrier de conformité",
    "addToOutlook": "Ajouter à Outlook",
    "viewSource2": "Voir Source",
    "policyRequirements": "Prescriptions générales",
    "extractedClausesRemainAvailableGroupedForEasierReview": "les clauses extraites restent disponibles, regroupées pour un examen plus facile.",
    "expandAll": "Élargir tout",
    "collapseAll": "Effondrement de tous",
    "confidencePage": "% de confiance · page",
    "privanaSInterpretation": "Privana ’ interprétation",
    "sourceDocuments": "Documents de sources",
    "originalDocumentsUsedForThisAnalysis": "Documents originaux utilisés pour cette analyse.",
    "addPDFs": "Ajouter des PDF",
    "pages": "pages ·",
    "view": "Afficher",
    "removeDocument": "Supprimer le document",
    "analysePolicy": "Analyse",
    "privanaLibraryControl": "Privana Contrôle de la bibliothèque",
    "suggestedControl": "Proposition de contrôle",
    "reviewThisReadOnlyLibraryControlBeforeAddingItToYourProgramme": "Révisez ce contrôle de bibliothèque en lecture seule avant de l'ajouter à votre programme.",
    "reviewPrivanaSRecommendationBeforeAddingItToYourComplianceProgramme": "Révisez la recommandation de Privana avant de l’ajouter à votre programme de conformité.",
    "destination": "Destination",
    "chooseTheFrameworkDestinationPrivanaWillRememberItWhileYouReviewAndActivateTheDraftControl": "Choisissez la destination-cadre. Privana se souviendra de celle-ci pendant que vous examinez et activez le projet de contrôle.",
    "targetFrameworkVersion": "Version ci-après",
    "chooseAFrameworkVersion": "Choisissez une version cadre",
    "evaluation2": "Évaluation :",
    "source": "Source",
    "privanaLibrary": "Privana Bibliothèque ·",
    "libraryControlTemporarilyUnavailable": "Contrôle des bibliothèques temporairement indisponible",
    "privanaCannotSafelyLoadThisHistoricalLibraryControlRightNowNoGeneratedControlWillBeSubstituted": "Privana ne peut pas charger en toute sécurité ce contrôle historique de la Bibliothèque en ce moment. Aucun contrôle généré ne sera substitué.",
    "creating": "Créer...",
    "createDraftControlContinue": "Créer un projet de contrôle & continuer",
    "analysisHistory": "Historique des analyses",
    "pages2": "pages",
    "privanaProvidesPolicyInterpretationAndAssuranceSupportNotLegalCertificationReviewMaterialInsuranceMattersWithYourBrokerInsurerOrProfessionalAdviser": "Privana fournit des services d'interprétation et d'assurance de la politique, et non une certification légale. Examiner les questions d'assurance matérielle avec votre courtier, assureur ou conseiller professionnel.",
    "insuranceIntelligenceCouldNotBeLoaded": "Le renseignement d'assurance ne peut pas être chargé.",
    "thePolicySetCouldNotBeCreated": "L ' ensemble de politiques n ' a pas pu être créé.",
    "turnComplexInsuranceWordingIntoClearObligationsAssuranceGapsAndActionsForYourClub": "Transformez le libellé d'assurance complexe en obligations claires, lacunes d'assurance et actions pour votre club.",
    "uploadInsurancePolicy": "Transférer la politique d'assurance",
    "privanaUsesAIToIdentifyAndOrganizePotentiallyImportantPolicyWordingReviewMaterialCoverageAndContractualQuestionsWithYourBrokerInsurerOrProfessionalAdviserWhereAppropriate": "Privana utilise AI pour identifier et organiser des formulations stratégiques potentiellement importantes. Examiner la couverture matérielle et les questions contractuelles avec votre courtier, assureur ou conseiller professionnel, le cas échéant.",
    "policyTitle": "Titre de la politique",
    "insuranceType": "Type d ' assurance",
    "insurerOptional": "Assureur (facultatif)",
    "policyNumberOptional": "Numéro de la politique (facultatif)",
    "createThePolicySetFirstThenSecurelyAddUpTo10PrivatePDFs100MBAnd1500PagesEachClassifyEachScheduleWordingOrEndorsementAndStartDurableAnalysis": "Créer la politique d'abord, puis ajouter en toute sécurité jusqu'à 10 PDF privés (100 Mo et 1500 pages chacun), classer chaque horaire, libellé ou approbation, et commencer une analyse durable.",
    "createPolicySet": "Créer un ensemble de politiques",
    "completedSafetyChecklists": "Listes de vérification de la sécurité complétées",
    "riskAssessments": "Évaluations des risques",
    "alertEvents": "Événements d’alerte",
    "theSourceProvidesSupportingAssuranceForTheControl": "La source fournit l'assurance pour le contrôle.",
    "theSourceMayDemonstrateThatTheControlIsNotBeingSatisfied": "La source peut démontrer que le Contrôle n'est pas satisfait.",
    "theSourceDemonstratesCorrectiveRemediationActivity": "La source démontre l'activité corrective et corrective.",
    "theSourceIndependentlyVerifiesTheControlCondition": "La source vérifie de façon indépendante l'état de contrôle.",
    "thisNativeEvidenceSourceIsNotSupported": "Cette source de preuve n'est pas supportée.",
    "thatSourceCapabilityIsNotAvailable": "Cette capacité de source n'est pas disponible.",
    "selectAValidActiveControl": "Sélectionnez un contrôle actif valide.",
    "theRequestedMappingOrControlIsNoLongerAvailable": "La cartographie ou le contrôle demandé n'est plus disponible.",
    "mappingsCanOnlyTargetActiveControls": "Les cartes peuvent uniquement cibler les contrôles actifs.",
    "selectAValidEvidenceRelationship": "Sélectionnez une relation Preuve valide.",
    "recordsConsideredPerSyncMustBeAWholeNumberFrom1To250": "Les documents considérés par synchronisation doivent être un nombre entier de 1 à 250.",
    "theSourceConfigurationIsTooLarge": "La configuration source est trop grande.",
    "thisSourceIsAlreadyMappedToThatControl": "Cette source est déjà cartographiée à ce Contrôle.",
    "providerSourceCapabilityAndControlCannotBeChanged": "Le fournisseur, la capacité de source et le contrôle ne peuvent pas être changés.",
    "youDoNotHavePermissionToChangeIntegrations": "Vous n'avez pas la permission de changer Intégrations.",
    "theIntegrationsOperationCouldNotBeCompleted": "L'opération Intégrations n'a pas pu être terminée.",
    "never": "Jamais",
    "editMapping": "Modifier la cartographie",
    "addMapping": "Ajouter la cartographie",
    "sourceCapability": "Capacité de Source",
    "activeControl": "Contrôle actif",
    "searchKeyOrTitle": "Rechercher la clé ou le titre...",
    "selectAnActiveControl": "Sélectionnez un contrôle actif",
    "relationship": "Relation",
    "recordsConsideredPerSync": "Documents examinés par synchronisation",
    "limitsHowManyRecentSourceRecordsPrivanaReviewsDuringEachSync": "Limite le nombre d'évaluations récentes de source Privana lors de chaque synchronisation.",
    "enabled": "Activé",
    "saveMapping": "Enregistrer la correspondance",
    "mappings": "mappages",
    "mapNativeSourceCapabilitiesToActiveControlsDisablingAMappingOnlyAffectsFutureSyncsHistoricalEvidenceRemainsUnchanged": "Carte des capacités des sources indigènes aux contrôles actifs. La désactivation d'une cartographie n'affecte que les synchronisations futures; la preuve historique demeure inchangée.",
    "noSupportedSourceCapabilitiesAreCurrentlyAvailableForThisClub": "Aucune capacité de source supportée n'est actuellement disponible pour ce club.",
    "addMapping2": "Ajouter Mapping",
    "noMappingsConfigured": "Pas de correspondances configurées.",
    "configuration": "Configuration",
    "disabled": "Désactivé",
    "latest": "Dernières",
    "disable": "Désactiver",
    "enable": "Activer",
    "syncCouldNotBeCompletedPleaseTryAgain": "Sync n'a pas pu être terminé. Veuillez réessayer.",
    "loadingNativeIntegrations": "Chargement des intégrations indigènes...",
    "nativeEvidenceIntegrations": "Intégration des données probantes autochtones",
    "configureAndOperateTrustedPrivanaSourcesThatProduceComplianceEvidence": "Configurer et exploiter des sources fiables de Privana qui produisent des preuves de conformité.",
    "addIntegration": "Ajouter Intégration",
    "addAnIntegration": "Ajouter une intégration",
    "discoverTrustedEvidenceSourcesForYourAssuranceProgramme": "Découvrez des sources de données fiables pour votre programme d'assurance.",
    "useCompletedSafetyChecksAndRiskAssessmentsAsTrustedComplianceEvidence": "Utiliser les vérifications de sécurité et les évaluations des risques comme preuve de conformité fiable.",
    "native": "Natif",
    "comingSoon": "Bientôt",
    "bringIdentityMFAPrivilegedAccessAndSecurityAssuranceSignalsIntoPrivanaCompliance": "Apportez des signaux d'identité, MFA, d'accès privilégié et d'assurance sécurité dans Privana Conformité.",
    "moreComingSoon": "Plus vite !",
    "privanaIsContinuallyExpandingTheSystemsThatCanContributeTrustedComplianceEvidence": "Privana élargit continuellement les systèmes qui peuvent contribuer à la confiance des Preuves de conformité.",
    "nATIVE": "NATIF",
    "configured": "Configurer",
    "readyToConfigure": "Prêt à configurer",
    "available2": "Disponible",
    "unavailable": "Indisponible",
    "enabledMappings": "Mappages activées",
    "evidenceProduced": "Données produites",
    "lastOutcome": "Dernier résultat",
    "completedWithErrors": "Complété avec des erreurs",
    "successful": "Succès",
    "notSynced": "Pas synchronisé",
    "sourceCapabilities": "Capacités de source",
    "lastSync": "Dernière sync",
    "viewEvidence": "Voir la preuve",
    "syncing": "Syncing...",
    "syncNow": "Synchronisez maintenant",
    "syncComplete": "Synchronisation complète",
    "integrationUnavailable": "Intégration non disponible",
    "thisProviderIsNotCurrentlyAvailableForYourClubRefreshThePageOrContactAnAdministrator": "Ce fournisseur n'est pas actuellement disponible pour votre club. Rafraîchissez la page ou contactez un administrateur.",
    "search": "Cherche...",
    "remediationActions": "mesures d ' assainissement",
    "actionsTrackTheWorkRequiredToRemediateComplianceFindings": "Les actions suivent le travail requis pour réinitialiser les conclusions de conformité.",
    "findingsTrackComplianceGapsIdentifiedThroughAssessmentsAndAssuranceReviews": "Les constatations suivent les lacunes en matière de conformité identifiées par les évaluations et les examens d'assurance.",
    "raiseFindingsFromEligibleAssessmentResults": "Relever les résultats des évaluations admissibles.",
    "completionSummary": "Résumé",
    "blockedReason": "Justification bloquée",
    "cancellationRationale": "Justification de l ' annulation",
    "action": "Action",
    "due": "Sommes dues",
    "overdue2": " · En retard",
    "start": "Commencez",
    "block": "Bloquer",
    "complete2": "Complet",
    "resume": "Consommation",
    "unableToLoadFindings": "Incapable de charger les résultats.",
    "closureSummary": "Résumé de la clôture",
    "complianceFindings": "Constatations de conformité",
    "formalDeficienciesAndExceptionsRaisedFromCanonicalAssessmentResults": "Déficits formels et exceptions découlant des résultats des évaluations canoniques.",
    "openFindings2": "Constatations ouvertes",
    "readyForReview": "Prêt à l ' examen",
    "overdueActions": "Actions en retard",
    "findingStatus": "Constatation du statut",
    "findingSeverity": "Trouve la gravité",
    "allSeverities": "Toutes les disparités",
    "overdue3": "en retard",
    "assessmentResult": "Résultat de l ' évaluation",
    "closed": "Fermé",
    "remediationActions2": "Mesures correctives",
    "actionTitle": "Titre d ' action",
    "selectActionOwner": "Sélectionnez le propriétaire de l'action",
    "addAction": "Ajouter une action",
    "noRemediationActionsYet": "Il n'y a pas encore de mesures d'assainissement.",
    "theDailyWorkQueueForResolvingComplianceFindings": "La queue de travail quotidienne pour résoudre les constatations de conformité.",
    "actionStatus": "État d ' avancement",
    "allPriorities": "Toutes les priorités",
    "dueState": "État requis",
    "allDueDates": "Toutes les dates attendues",
    "dueSoon": "Bientôt",
    "noDueDate": "Sans échéance",
    "unknownFailure": "L'opération de conformité n'a pas pu être terminée.",
    "noControls": "Pas de contrôle.",
    "noFrameworks": "Pas encore de cadre",
    "noActions": "Pas encore d ' actions d ' assainissement",
    "noFindings": "Pas encore de conclusions",
    "evaluatedCount": "{evaluated} / {total} évaluées",
    "completionPercent": "{percent} complet",
    "assessmentIncomplete": "Cette évaluation ne peut pas encore être terminée. {count} commandes restent non évaluées {references} .",
    "allStatus": "Tous les statuts",
    "allFrameworks": "Tous les cadres",
    "allAssessmentTypes": "Tous les types d ' évaluation",
    "allResults": "Tous les résultats",
    "stepNumber": "Étape {step}",
    "assessedScope": "{assessed} de {total} versions de cadre actuelles évaluées · {controls} commandes applicables",
    "findingSeverityCounts": "{critical} critique · {high} haut",
    "dueCounts": "Sommes dues en 30 jours · {overdue} en retard",
    "timesIn": "Heures affichées dans {timezone}",
    "selectDate": "Sélectionnez {date}",
    "ownerName": "Propriétaire: {owner}",
    "priorityLevel": "{priority} priorité",
    "moreCount": "+ {count} plus",
    "openTarget": "Ouvrir {target}",
    "dateTime": "Date et heure",
    "orderNumber": "Ordonnance {order}",
    "referenceFor": "Référence cadre pour {control}",
    "reorderControl": "Réordonner ou supprimer {control}",
    "previewName": "Aperçu · {name}",
    "versionSuccess": "Version {status} avec succès.",
    "versionNumber": "Version {version}",
    "suggestedReviewCounts": "{total} suggéré Contrôles · {approved} approuvé · {awaiting} en attente d'examen",
    "readyActiveCounts": "{active} / {total} Active · Prêt à activer la version",
    "reviewedControls": "{reviewed} de {total} Contrôles examinés",
    "selectControl": "Sélectionnez {control}",
    "activatedControls": "Contrôles activés : {count}.",
    "evidenceTransition": "Pourquoi cette preuve est-elle de {status} ?",
    "analysingPolicy": "Analyse {title} · {percent}",
    "documentsCountOne": "Documents : {count}",
    "documentsCountOther": "Documents : {count}",
    "reviewCount": "Pour examiner {count}",
    "completedCount": "Complété {count}",
    "addToFrameworkName": "Ajouter à {name}",
    "importanceLevel": "importance {importance}",
    "providerUnavailable": "{provider} capacité n'est pas disponible pour ce club.",
    "providerMappings": "cartes {provider}",
    "elementDescription": "Utilisez les événements d'alerte surveillés et les exceptions physiques dans le monde comme preuve de conformité fiable.",
    "mappingView": "Voir Mappings",
    "mappingManage": "Gérer les cartes",
    "configure": "Configurer",
    "syncNeedsMapping": "Ajouter au moins une cartographie activée avant la synchronisation.",
    "syncNeedsAvailable": "Activer une cartographie pour une capacité source disponible avant la synchronisation.",
    "overdueCount": "En retard : {count}",
    "insuranceQueued": "Filed",
    "insurancePreparingdocuments": "Préparation des documents",
    "insuranceReadingpolicy": "Politique de lecture",
    "insuranceIdentifyingrequirements": "Identifier les prescriptions",
    "insuranceCheckingyourCompliancecontrols": "Contrôle de vos contrôles de conformité",
    "insurancePreparingrecommendations": "Préparer les recommandations",
    "insuranceFinalisinganalysis": "Analyse finale",
    "insuranceAnalysisfailed": "Analyse échouée",
    "insuranceExclusions": "Exclusions",
    "insuranceConditionsofcover": "Conditions de couverture",
    "insuranceRecommendations": "Recommandations",
    "insuranceDefinitionspolicyinformation": "Définitions et information politique",
    "insuranceClaimsnotification": "Claims \" notification",
    "insuranceDataprotectionprivacy": "Protection des données et confidentialité",
    "insuranceIncidentresponse": "Réponse incidente",
    "insuranceOperationalresilience": "Résistance opérationnelle",
    "insuranceSecurityrequirements": "Prescriptions relatives à la sécurité",
    "insuranceGovernancepeople": "Gouvernance et personnes",
    "insuranceOtherpolicywording": "Autres formulations de politiques",
    "evidenceMethodSummary": " · Preuve : {method}",
    "diagnostic": "{message} (Code: {code} ; Demande: {request} )",
    "nativeChecklist": "Liste de vérification de sécurité: {title}",
    "nativeRisk": "Évaluation des risques : {title}",
    "nativeElement": "Alerte à l'élément: {title}",
    "nativeResult": "Complété avec résultat {result} .",
    "nativeRiskDescription": "Note de risque {score} ; état {status} .",
    "controlCount": "Contrôles : {count}",
    "continue": "Continuer",
    "messageControls": "{value1} ( {value2} ) · {value3} · {value4} commandes",
    "messageCompleted2": "{value1} · {value2} · Terminé {value3}",
    "messageCreated": "Créé {value1}",
    "messageEvaluated": "{value1} / {value2} évaluées",
    "messageControlVersion": "{value1} · {value2} · Version de contrôle {value3}",
    "messageFinding": "Trouver {value1} · {value2}",
    "messageTimesShownIn": "Heures affichées dans {value1}",
    "messageManifestV": "Manifeste v {value1} · SHA-256 {value2}",
    "messageTimesShownIn2": "Heures affichées dans {value1}",
    "messageMore": "+ {value1} plus",
    "messageAvailable": "{value1} disponible",
    "messageVersion2": "{value1} · {value2} · Version {value3}",
    "messageAssigned": "Affectés : {value1}",
    "messageVersion22": "{value1} · {value2} · Version {value3}",
    "messageFrameworkReferenceFor": "Référence cadre pour {value1}",
    "messageControlsAssigned": "{value1} Contrôles assignés",
    "messageSuggestedEvidence": "{value1} · Preuve suggérée: {value2}",
    "messagePrivanaTemplate": "Privana template · {value1} Contrôles",
    "messageSelected": "Sélectionnés : {value1}",
    "messageVersion": "Version {value1}",
    "messageControls2": "Contrôles : {value1}",
    "messageReviewed": "{value1} / {value2} examinés",
    "messageVersion23": "{value1} · {value2} · Version {value3}",
    "messageSelected2": "Sélectionnés : {value1}",
    "messageEvidence2": "{value1} · {value2} · Preuve: {value3}",
    "messageSelected3": "Sélectionnés : {value1}",
    "messageVersion3": "Version {value1}",
    "messagePage": "Page {value1} · {value2}",
    "messageInsuranceIntelligence3": "Renseignements sur l'assurance · {value1}",
    "messageAnalysing": "Analyse {value1}",
    "messageOf": "{value1} · {value2} de {value3} pages traitées",
    "messagePage2": "{value1} · page {value2} · Voir la source",
    "messageOf2": "{value1} de {value2} examinés · {value3} restants",
    "messageExistingMatches": "{value1} matchs existants · {value2} suggéré Contrôles · {value3} dates · {value4} examen des besoins",
    "messageReview": "Revue {value1} →",
    "messageStatus2": "Statut: {value1}",
    "messageFrameworks2": "Cadres: {value1}",
    "messageLatestAssessment": "Dernière évaluation: {value1}",
    "messageEvidence3": "Preuve : {value1}",
    "messageLibraryProvenance": "Provenance de la bibliothèque: {value1} · version {value2} · {value3}",
    "messageTarget": "Cible : {value1} · Version {value2}",
    "messagePage3": "Page {value1} · Voir la source",
    "messageAll": "Toutes les {value1} clauses extraites restent disponibles, regroupées pour un examen plus facile.",
    "messageConfidencePage": "{value1} % de confiance · page {value2}",
    "messagePage22": "{value1} · page {value2} · Voir la source",
    "messagePages": "{value1} · {value2} · {value3} pages · {value4}",
    "messageVersion24": "{value1} · Version {value2} · {value3} · {value4} Contrôles",
    "messageEvaluation2": "Évaluation: {value1} · Preuve: {value2}",
    "messagePrivanaLibrary": "Privana Bibliothèque · {value1} · Version {value2} · {value3}",
    "messagePage23": "{value1} · page {value2} · Voir la source",
    "messagePages2": "{value1} pages",
    "messageMappings": "cartes {value1}",
    "messageLatest": "Dernières {value1}",
    "messageOverdue3": "En retard : {value1}",
    "criticalHigh": "Critique / élevée",
    "frameworkControl": "Cadre / Contrôle",
    "outlookRenewal": "Préparer {title} Renouvellement",
    "outlookPolicy": "Politique: {title}",
    "outlookInsurer": "Assureur: {name}",
    "outlookNumber": "Numéro de la politique: {number}",
    "outlookExpiry": "Expiration: {date}",
    "futureRelease": "Cet espace de travail est prêt pour un futur communiqué de conformité."
  },
  "enums": {
    "low": "Faible",
    "medium": "Moyen",
    "high": "Élevé",
    "critical": "Critique",
    "open": "Ouvrir",
    "active": "Actif",
    "draft": "Brouillon",
    "retired": "Retraite",
    "superseded": "Supersed",
    "withdrawn": "Retiré",
    "applicable": "Cas échéant",
    "not_applicable": "Non applicable",
    "under_review": "À l ' examen",
    "in_progress": "En cours",
    "completed": "Terminé",
    "cancelled": "Annulé",
    "accepted": "Acceptée",
    "remediation_in_progress": "L ' assainissement en cours",
    "ready_for_review": "Prêt pour l'examen",
    "closed": "Fermé",
    "void": "Annulé",
    "blocked": "Bloqué",
    "compliant": "Compliquant",
    "partially_compliant": "Partiellement fiable",
    "non_compliant": "Non fiable",
    "not_evaluated": "Non évaluée",
    "initial": "Initiale",
    "periodic": "Périodique",
    "reassessment": "Réévaluation",
    "manual": "Manuel",
    "automated": "Automatisé",
    "integrated": "Intégré",
    "hybrid": "Hybride",
    "manual_attestation": "Attestation manuelle",
    "document": "Document",
    "system_evidence": "Preuve de système",
    "integrated_evidence": "Preuve intégrée",
    "sensor_telemetry": "Télémétrie de capteur",
    "uploaded_document": "Document téléchargé",
    "privana_safety": "Privana Sécurité",
    "privana_element": "Privana Élément",
    "completed_checklist": "Liste de contrôle complète",
    "risk_assessment": "Évaluation des risques",
    "alert_event": "Événement d’alerte",
    "supports": "Appuis",
    "contradicts": "Contredits",
    "remediates": "Remédiats",
    "verifies": "Verifie",
    "control": "Contrôle",
    "assessment": "Évaluation",
    "finding": "Trouver",
    "action": "Action",
    "framework": "Cadre",
    "framework_version": "Version cadre",
    "evidence": "Preuve",
    "evidence_link": "Lien de preuve",
    "audit_pack": "Pack de vérification",
    "generating": "Génératrice",
    "generated": "Générée",
    "queued": "Filed",
    "processing": "Traitement",
    "failed": "Échec",
    "error": "Erreur",
    "uploaded": "Téléchargé",
    "uploading": "Téléchargement",
    "policy_wording": "Formulation des politiques",
    "policy_schedule": "Calendrier des politiques",
    "endorsement": "Approbation",
    "renewal_terms": "Conditions de renouvellement",
    "supporting_document": "Document d ' appui",
    "other": "Autre",
    "to_review": "D ' examen",
    "reviewed": "Révisé",
    "adopted": "Adoptée",
    "dismissed": "Rompez.",
    "exclusion": "Exclusion",
    "condition": "Condition",
    "recommendation": "Recommandation",
    "definition": "Définition",
    "informational": "À titre informatif",
    "coverage": "Couverture",
    "notification_obligation": "Obligation de notification",
    "warranty": "Garantie",
    "obligation": "Obligation",
    "assessmentCoverage": "ÉvaluationCoverage",
    "findingResolution": "De la résolution",
    "actionTimeliness": "ActionTimelines",
    "evidenceCoverage": "La couverture des preuves",
    "scanned": "Scannétisés",
    "created": "Créé",
    "unchanged": "Non échangée",
    "linked": "Lié au lien",
    "skipped": "Ignoré",
    "sourceErrors": "Erreurs de source",
    "linkErrors": "LienErrors",
    "current": "Actuel",
    "historical": "Historique",
    "pass": "Passage",
    "fail": "Échouement",
    "review_due": "Examen attendu",
    "privana_object_storage": "Privana Stockage d'objets",
    "actions": "Actions",
    "frameworks": "Cadres",
    "assessments": "Évaluations",
    "control_created": "Contrôle Créé",
    "control_updated": "Contrôle mis à jour",
    "control_status_changed": "État de contrôle modifié",
    "control_version_created": "Version de contrôle créée",
    "framework_created": "Cadre créé",
    "framework_version_created": "Version cadre Créée",
    "framework_control_linked": "Contrôle-cadre lié",
    "framework_control_unlinked": "Contrôle-cadre Unlinked",
    "framework_controls_reconciled": "Contrôles-cadres Réconciliés",
    "framework_control_copied": "Contrôle-cadre copié",
    "framework_created_from_library": "Cadre créé à partir de Bibliothèque",
    "control_created_from_library": "Contrôle créé à partir de la bibliothèque",
    "framework_status_changed": "État-cadre modifié",
    "framework_version_status_changed": "Version cadre État modifié",
    "framework_applicability_changed": "Applicabilité du cadre modifiée",
    "assessment_created": "Évaluation Créée",
    "assessment_status_changed": "État d ' évaluation modifié",
    "assessment_results_initialized": "Résultats de l ' évaluation",
    "assessment_result_recorded": "Résultat de l'évaluation enregistré",
    "finding_created": "La recherche",
    "finding_metadata_changed": "Trouver des métadonnées modifiées",
    "finding_status_changed": "Constatation du statut modifié",
    "action_created": "Action créée",
    "action_metadata_changed": "Métadonnées de l’action modifiées",
    "action_status_changed": "État d ' action modifié",
    "evidence_created": "Preuves créées",
    "evidence_document_uploaded": "Document de preuve Téléchargé",
    "evidence_metadata_changed": "Les métadonnées probantes modifiées",
    "evidence_status_changed": "État de la preuve modifié",
    "evidence_linked": "Preuves liées",
    "evidence_unlinked": "Les éléments de preuve non liés",
    "evidence_source_mapping_created": "Éléments de preuve Source Mapping Created",
    "evidence_source_mapping_changed": "Preuve Source Mapping Changed",
    "evidence_source_mapping_disabled": "Preuve Source Mapping Disabled",
    "trusted_evidence_created": "Preuves de confiance Créées",
    "integrated_evidence_superseded": "Preuves intégrées Supermises",
    "audit_pack_created": "Paquet de vérification Créé",
    "audit_pack_generated": "Pack de vérifications Générée",
    "audit_pack_voided": "Pack de vérification Voided",
    "controls": "Contrôles",
    "findings": "Constatations",
    "evidence_records": "Documents de preuve",
    "current_evidence": "Preuves actuelles",
    "current_documents_included": "Documents en cours",
    "suggested": "Proposé",
    "confirmed": "Confirmé",
    "insurance": "Assurance",
    "insurance_policy": "Politique d'assurance",
    "insurance_document": "Document d ' assurance",
    "insurance_date": "Date d ' assurance",
    "insurance_analysis": "Analyse des assurances",
    "insurance_document_uploaded": "Document d'assurance Téléchargé",
    "insurance_analysis_started": "Analyse de l ' assurance",
    "insurance_calendar_event_added": "Calendrier d ' assurance",
    "preparing": "Préparation",
    "validating": "Validation",
    "evidence_source_mapping": "Preuve Source Mapping",
    "verified": "Vérifié",
    "partial": "Partiel",
    "not_started": "Pas commencé"
  },
  "controlValues": {
    "importance": {
      "low": "Faible",
      "medium": "Moyen",
      "high": "Élevé",
      "critical": "Critique"
    },
    "evaluationMethod": {
      "manual": "Examen manuel",
      "automated": "Examen automatisé",
      "integrated": "Examen intégré",
      "hybrid": "Examen hybride"
    },
    "evidenceMethod": {
      "manual_attestation": "Attestation manuelle",
      "document": "Examen des documents",
      "system_evidence": "Preuves du système",
      "integrated_evidence": "Éléments de preuve intégrés",
      "sensor_telemetry": "Télémétrie du capteur",
      "hybrid": "Essais hybrides"
    }
  },
  "assurance": {
    "Not Assessed": "Pas évalué",
    "At Risk": "Risque",
    "Attention Needed": "Attention nécessaire",
    "Strong": "Fort"
  },
  "report": {
    "title": "Pack de vérification",
    "brand": "COMPLIANCE PRIVANA",
    "generated": "Générée {date}\nfuseau horaire: {timezone}\nIntégrité SHA-256: {hash}",
    "executive": "Résumé",
    "summary": "{assessment} contre {framework} {version} . Commandes: {controls} ; constatations: {findings} ; actions: {actions} ; documents de preuve: {evidence} .",
    "frameworkAssessment": "Cadre d ' évaluation",
    "scope": "Cadre: {key} — {framework}\nVersion: {version} ( {status} )\nDates d'entrée en vigueur : {from} à {to}\nÉvaluation: {assessment} ( {type} )\nDémarré: {started}\nComplété: {completed}",
    "openEnded": "ouvert",
    "controlResults": "Résultats du contrôle",
    "noNarrative": "Aucune narration",
    "evaluated": " · Évalué {date}",
    "findings": "Constatations",
    "closed": " · Fermé {date}",
    "noFindings": "Aucun résultat n'a été enregistré.",
    "actions": "Mesures correctives",
    "due": "{date}",
    "completed": " · Complété {date}",
    "noActions": "Aucune mesure d'assainissement n'a été enregistrée.",
    "evidence": "Registre des preuves",
    "noEvidence": "Aucune preuve n'a été enregistrée.",
    "audit": "Journal d’audit",
    "integrity": "Génération / Intégrité Information",
    "integrityText": "Format du Manifeste: {version}\nHash convention: SHA-256 de la charge utile JSON canonique à l'exclusion du membre d'intégrité.\nManifest hash: {hash}\nIl s'agit d'un instantané historique immuable, pas d'une certification réglementaire.",
    "page": "Privana · {key} · Page {page} de {total}"
  },
  "warnings": {
    "non_compliant": "L'évaluation a des résultats non conformes",
    "open_findings": "Les conclusions ouvertes demeurent",
    "findings_review": "Les résultats sont prêts à être évalués",
    "withdrawn_evidence": "La preuve retirée est liée à la portée",
    "missing_evidence": "Les contrôles pertinents n'ont pas de preuve positive active"
  }
};
